import { render, staticRenderFns } from "./AddEditField.vue?vue&type=template&id=7c28f700"
import script from "./AddEditField.vue?vue&type=script&lang=js"
export * from "./AddEditField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports